import { Entity } from '../../../core/context/entity';

interface AssetCustomAttribute {
    label: string;
    definitionId: string;
    value?: string | null;
}

interface AssetProps {
    id: string;
    zoneId: string;
    inScope: boolean;
    itemIds: string[];
    status: string;

    attckAssetTypeId?: string;
    criticalityId?: string;
    impactJustification?: string;
    name?: string;
    description?: string;
    alias?: string;
    assetType?: string;
    attributes?: AssetCustomAttribute[];
}

export class Asset extends Entity {
    zoneId: string;
    itemIds: string[];
    inScope: boolean;
    status: string;

    attributes?: AssetCustomAttribute[];
    description?: string;
    alias?: string;
    assetType?: string;
    attckAssetTypeId?: string;
    impactJustification?: string;
    criticalityId?: string;

    constructor({
        id,
        name,
        description,
        alias,
        assetType,
        inScope,
        criticalityId,
        attckAssetTypeId,
        zoneId,
        itemIds,
        status,
        impactJustification,
        attributes,
    }: AssetProps) {
        super({ id, name });
        this.description = description;
        this.alias = alias;
        this.assetType = assetType;
        this.zoneId = zoneId;
        this.inScope = inScope;
        this.attckAssetTypeId = attckAssetTypeId;
        this.criticalityId = criticalityId;
        this.itemIds = itemIds;
        this.status = status;
        this.impactJustification = impactJustification;
        this.attributes = attributes;
    }
}
